import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class PlayAudiosService {
  playBeepSound() {
    const audio = this.prepareSound("assets\\audios\\beep.mp3");
    audio.play();
  }

  playBeepSoundOK() {
    const audio = this.prepareSound("assets\\audios\\OK.mp3");
    audio.play();
  }

  playAudioError() {
    const audio = this.prepareSound(`${environment.baseUrl}assets\\audios\\beepError.wav`);
    audio.play();
  }

  playAudioError2() {
    const audio = this.prepareSound(`${environment.baseUrl}assets\\audios\\ERRO.mp3`);
    audio.play();
  }

  public playWarningSound() {
    const audio = this.prepareSound("assets\\audios\\beep-warning.mp3");
    audio.play();
    return audio;
  }

  public playAttentionSound() {
    const audio = this.prepareSound("assets\\audios\\beep-remove.mp3"); //nome do arquivo e beep remove pq inicialmente foi pensado em usar apenas no remover na pre-fae
    audio.play();
    return audio;
  }

  private prepareSound(src?: string) {
    const audio = new Audio(src);
    audio.load();
    return audio;
  }

  public playAudioSuccess() {
    const audio = this.prepareSound(`${environment.baseUrl}assets\\audio\\beepSuccess.mp3`);
    audio.play();
  }
}
